module.exports = __webpack_public_path__ + "img/ปลาเทราท์.8f6e4dc5.png";